import { t } from "i18next";
import { CorePropsInterfaces, DTOs } from "src/core/Models";
import GtDialog from "./GtDialog";
import { Button, TextField } from "@mui/material";
import { useState } from "react";

function GtCancelSigningDialog({
  onCancelSigning,
  onDialogClose,
}: CorePropsInterfaces.GtCancelSigningDialogProps): JSX.Element {
  const [comment, setComment] = useState("");
  const changeCancelSigningDialogDTO: DTOs.GtDialogDTO = {
    data: {
      title: t("General.CancelSignProcess"),
      maxWidth: "sm",
      leftButtons: [],
      rightButtons: [
        <Button
          onClick={onDialogClose}
          color="tertiary"
          variant="outlined"
          key="cancelBtn"
        >
          {t("General.Cancel")}
        </Button>,
        <Button
          color="tertiary"
          variant="contained"
          key="confirmBtn"
          onClick={() => {
            onCancelSigning(comment);
          }}
        >
          {t("General.Confirm")}
        </Button>,
      ],
    },
    api: {
      onClose: onDialogClose,
    },
    state: {
      isOpen: true,
      isFullWidth: true,
    },
  };

  return (
    <GtDialog gtDialogDTO={changeCancelSigningDialogDTO}>
      <article className="gt-saveFormContent">
        <section className="gt-saveFormContent__row">
          <div className="gt-saveFormContent__row-titleContainer">
            <span className="gt-saveFormContent__row-titleContainer-title">
              {t("General.Comment")}
            </span>
          </div>
          <div className="gt-saveFormContent__row-inputContainer">
            <TextField
              className="gt-MultilineField"
              multiline
              minRows={5}
              inputProps={{ maxLength: 300 }}
              variant="outlined"
              onChange={(evt) => setComment(evt.target.value)}
              value={comment}
            />
          </div>
        </section>
      </article>
    </GtDialog>
  );
}

export default GtCancelSigningDialog;
